module.exports = __webpack_public_path__ + "img/20191019153954808.2b808843.jpg";